module.exports = __webpack_public_path__ + "img/2.33cb3f2b.png";